const usersData = [
{ name:'Campus', active_status: 'Active' },
{ name:'Lanjut Usia', active_status: 'Active' },
{ name:'Married Couples', active_status: 'Active' },
{ name:'Pro-M', active_status: 'Active' },
{ name:'Youth', active_status: 'Active' },



]

export default usersData


